import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.split";

function t(t) {
  var i = ("undefined" == typeof window ? Buffer.from(t, "base64").toString("utf-8") : atob(t)).split("shopify/")[1].split("/"),
      e = i[0],
      r = i[1],
      n = (r.split("?").slice(1)[0] || "").split("&").reduce(function (t, i) {
    var e = i.split("=");
    return t[e[0]] = e[1], t;
  }, {});
  return {
    type: e,
    id: r.split("?")[0],
    params: n,
    raw: t
  };
}

function i(t, i, e) {
  void 0 === e && (e = {});
  var r = "gid://shopify/" + t + "/" + i,
      n = [],
      f = Object.keys(e);

  if (f.length > 0) {
    for (var o = 0; o < f.length; o++) {
      n.push(f[o] + "=" + e[f[o]]);
    }

    r += n = "?" + n.join("&");
  }

  return "undefined" == typeof window ? Buffer.from(r, "utf-8").toString("base64") : btoa(r);
}

export { t as decode, i as encode };